import React from "react";
import { cls } from "cls";
import currencyFormatter from "@wss/utilities/formatAsCurrency";
import UnitOfMeasure from "../UnitOfMeasure";
import SaleBadgeAndPricing from "~/common/SaleBadgeAndPricing";

const textSizes = {
  small: cls("text-lg-1/2"),
  standard: cls("text-2xl"),
  custom: "",
};

interface PriceProps {
  price: number;
  displaySalePrice?: boolean;
  salePrice?: number;
  unitOfMeasure: string;
  className?: string;
  style?: React.CSSProperties;
  showFrom?: boolean;
  isOutlet?: boolean;
  textSize?: keyof typeof textSizes;
  productListingView?: string;
  hideRegularPriceOnSaleBadge?: boolean;
  quantityDiscountPrice?: number;
  extraSalePricingClassNames?: string;
}

const Price = ({
  price,
  displaySalePrice,
  salePrice,
  unitOfMeasure,
  className = "",
  style,
  showFrom,
  isOutlet,
  textSize = "standard",
  productListingView,
  hideRegularPriceOnSaleBadge = false,
  quantityDiscountPrice,
  extraSalePricingClassNames = "",
}: PriceProps) => {
  const textSizeClass = textSizes[textSize];

  const displayedPrice = () => {
    if (quantityDiscountPrice && quantityDiscountPrice > 0) {
      if (displaySalePrice && salePrice && salePrice < quantityDiscountPrice) {
        return currencyFormatter.format(salePrice);
      }
      return currencyFormatter.format(quantityDiscountPrice);
    }
    return currencyFormatter.formatIfUndefined(
      displaySalePrice ? salePrice : price,
    );
  };

  return (
    <div
      data-testid="price"
      className={`${className} ${textSizeClass} price font-semibold leading-none mb-0 relative text-red-500`}
      style={style}
    >
      {displaySalePrice && (
        <SaleBadgeAndPricing
          dataTestId="itemSale"
          price={price}
          salePricingClassNames={cls(
            "p-0 mb-0 text-xs text-gray-800 font-normal",
            productListingView === "grid" ? "pt-1 pb-1-1/2" : "pt-2 xs:py-1",
            extraSalePricingClassNames,
          )}
          saleBadgeExtraClassNames="px-1 mr-1 py-0.5"
          hideRegularPrice={hideRegularPriceOnSaleBadge}
        />
      )}
      {showFrom && (
        <>
          <span
            data-testid="from"
            className={`promo-ad-from text-2xs leading-4 uppercase block
              ${
                productListingView === "list"
                  ? cls("mt-0", "relative", "-top-1", "xs:static")
                  : ""
              }`}
          >
            From
          </span>{" "}
        </>
      )}
      {isOutlet ? <span className="sr-only">Outlet Price:</span> : null}
      {displayedPrice()}
      <UnitOfMeasure
        unitOfMeasure={unitOfMeasure}
        showBoldOutletFormatting={isOutlet}
      />
    </div>
  );
};

export default Price;
